
import React, { Component } from 'react';
import { SemiCircle } from 'react-progress-bar.js'
import * as Questions from  './questions'


export const GlobalDashboard = (props) => (
    <JumboTron {...props}/>
)

const JumboTron = (props) => (
    <div className={`jumbotron text-center alert-${props.tree.colorCode}`}>
        <SemiCircle
                progress={props.tree.score / props.tree.maxScore}
                options={ { color: Questions.colorStyle(props.tree.score / props.tree.maxScore), strokeWidth: 10, trailColor: '#ccc', trailWidth: 2}}
                initialAnimate={true}
                containerStyle={ { width: '12em', height: '9em'} }
                containerClassName={'mx-auto'} 
                />
        <h1 className="display-4">
            {   props.tree.percentage && 
                `${Math.round(props.tree.percentage * 100)}%`
                }
        </h1>
        <p className="small text-muted">
            {props.tree.score} pontos num total {props.tree.maxScore} pontos possíveis
        </p>
    </div>
)




// WEBPACK FOOTER //
// ./src/GlobalDashboard.jsx